
import { Vue, Component } from 'vue-property-decorator';
import HelpTooltip from '@/components/MapLayers/HelpTooltip.vue';
import LegendMenu from '@/components/MapLayers/LegendMenu.vue';
import VisualizationSettings from '@/components/MapLayers/VisualizationSettings.vue';
import { LayerItem, LayerType } from '@/types';
import { cloneDeep } from 'lodash';
import { mapLayerIds } from '@/assets/data/mapLayers';

@Component({
  components: { HelpTooltip, LegendMenu, VisualizationSettings },
})
export default class MapLayers extends Vue {
  lowerLegendHeight = 200;

  collapsed = false;

  get legendCollapsed(): boolean {
    return this.$vuetify.breakpoint.mdAndUp ? false : this.collapsed;
  }

  get showMenu(): boolean {
    return this.$store.getters.showMenu;
  }

  get menuItems(): LayerType[] {
    return this.$store.getters.menuItems;
  }

  get activeLayers(): LayerItem[] {
    let layers: LayerItem[] = [];

    this.menuItems.forEach(menuLayer => {
      menuLayer.items.forEach(item => {
        if (item.selected) {
          const activeLayer = cloneDeep(item);
          activeLayer.title = this.$t(
            `map.mapLegend.layers.${menuLayer.title}.layers.${item.title}`,
          ) as string;
          layers.push(activeLayer);
        }
      });
    });

    return layers;
  }

  toggleLayer(layer: { layerName: string; selected: boolean }) {
    this.$emit('toggleLayer', layer);
  }

  resizeLegend(lowerLegendHeight: number) {
    this.lowerLegendHeight = lowerLegendHeight;
  }

  updateChoropleth(showNodes: boolean) {
    this.toggleLayer({
      layerName: mapLayerIds.FLOW_TOOL_NODES,
      selected: showNodes,
    });

    this.$emit('updateChoropleth');
  }
}
